/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/services/app.bonus-punkte.service.ts.
 */
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {KundeBonuspunkt} from '../models/kunde-bonuspunkt';
import {Bonuspunktprogramm} from '../models/bonuspunktprogramm';
import {map} from 'rxjs/operators';
import {BonuspunktprogrammStufe} from '../models/bonuspunktprogramm-stufe';

/**
 * Zweck: Beschreibt class AppBonusPunkteService und ihren Daten- oder Funktionsvertrag.
 */
@Injectable({providedIn: 'root'})
export class AppBonusPunkteService {
/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private http: HttpClient) {
  }

/**
 * Beschreibt Methode getProgramme und ihren Rückgabevertrag.
 */
  getProgramme(): Observable<Bonuspunktprogramm[]> {
    return this.http.get<Bonuspunktprogramm[]>(
      '/bonuspunkte/programme'
    );
  }

/**
 * Beschreibt Methode getMeine und ihren Rückgabevertrag.
 */
  getMeine(): Observable<KundeBonuspunkt[]> {
    return this.http.get<KundeBonuspunkt[]>(
      '/bonuspunkte/meine'
    ).pipe(map(ps => {
      ps.forEach(p => {
        Object.setPrototypeOf(p, KundeBonuspunkt.prototype);

        if (p.Bonuspunkteprogramm) {
          Object.setPrototypeOf(p.Bonuspunkteprogramm, Bonuspunktprogramm.prototype);

          if (p.Bonuspunkteprogramm.BonuspunktprogrammStufen) {
            p.Bonuspunkteprogramm.BonuspunktprogrammStufen.forEach(s => {
              Object.setPrototypeOf(s, BonuspunktprogrammStufe.prototype);
            });
          }
        }
      });
      return ps;
    }));
  }
}
